import { Pipe, PipeTransform } from '@angular/core';
import { Settlement } from 'src/app/classes/settlement.class';
import { CONTRACT_HOURTYPE_CODES } from 'src/app/services/settlements.service';

@Pipe({
    name: 'cumulativeSettlementMinutes',
    standalone: false,
})
export class CumulativeSettlementMinutesPipe implements PipeTransform {
    transform(settlements: Settlement[], currentId: number) {
        return settlements
            .filter(
                settlement => settlement.id <= currentId && CONTRACT_HOURTYPE_CODES.includes(settlement.hourtype_code)
            )
            .reduce((sum, settlement) => sum + settlement.minutes, 0);
    }
}
